import React, { useState } from "react";
import { injectIntl } from "react-intl";
import TypeaheadBox from "../Form/TypeaheadBox";
import intlShape from "../../shapes/intlShape";
import { withApi, apiShape, withNotifier, notifierShape } from "../../context";
import { withUser } from "../../wrappers";
import { Column, Row } from "../Grid";

type Props = {
  api: apiShape;
  intl: intlShape;
  name: string;
  notifier: notifierShape;
  values?: {
    node?: $TSFixMe;
  };
  allowedPermissions?: $TSFixMe[]; // TODO: PropTypes.oneOf([ PermissionType.READ, PermissionType.UPDATE, PermissionType.DELETE, PermissionType.PERMIT, ])
  excludables?: $TSFixMe[];
};

export function NodeTypeahead(props: Props) {
  const [nodes, setNodes] = useState();
  const [fetching, setFetching] = useState();

  const { api, notifier, intl, values, name, excludables, allowedPermissions } =
    props;

  const loadOptions = async (searchText = "") => {
    try {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'true' is not assignable to param... Remove this comment to see the full error message
      setFetching(true);
      const response = await api.get("/nodes", {
        name: `${searchText}*`,
        permission: allowedPermissions,
      });
      const allNodes = response.nodes.map((node: $TSFixMe) => ({
        id: node.id,
        name: node.name,
      }));
      let validSelection = allNodes;
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      if (excludables?.length > 0) {
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        const idsToExclude = excludables.map((a) => a.id);
        validSelection = allNodes.filter(
          (record: $TSFixMe) => !idsToExclude.includes(record.id),
        );
      }
      setNodes(validSelection);
    } catch (error) {
      notifier.showError(api.translateError(error));
    } finally {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'false' is not assignable to para... Remove this comment to see the full error message
      setFetching(false);
    }
  };

  React.useEffect(() => {
    loadOptions();
  }, [JSON.stringify(excludables)]);

  // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
  const selectedNode = values[name];

  return (
    <Row>
      <Column>
        <TypeaheadBox
          {...props}
          // @ts-expect-error TS(2322) FIXME: Type '{ info: string | null; options: undefined; f... Remove this comment to see the full error message
          info={
            /* istanbul ignore next */
            selectedNode?.new
              ? intl.formatMessage({ id: "node_typeahead.new_info" })
              : null
          }
          options={nodes}
          fetching={fetching}
          loadOptions={loadOptions}
        />
      </Column>
    </Row>
  );
}

// @ts-expect-error TS(2345) FIXME: Argument of type '{ (props: Readonly<Omit<Readonly... Remove this comment to see the full error message
export default injectIntl(withUser(withNotifier(withApi(NodeTypeahead))));
